import React from 'react';
import styles from './ByopdfLoader.module.css';

// The BYOPDF loading mark: the logo's robot-book face come to life — it
// blinks, its mouth "narrates", and sound waves ripple out. Pure SVG + CSS
// (no JS timers), theme-aware, respects prefers-reduced-motion.
//
// Props:
//   size      px height of the mark (default 72)
//   label     optional caption under the mark
//   fullPage  center in the full viewport (for route/auth loading screens)
function ByopdfLoader({ size = 72, label = '', fullPage = false }) {
  return (
    <div
      className={`${styles.wrap} ${fullPage ? styles.fullPage : ''}`}
      role="status"
      aria-label={label || 'Loading'}
    >
      <svg
        className={styles.mark}
        width={size * (40 / 28)}
        height={size}
        viewBox="0 0 40 28"
        aria-hidden="true"
      >
        {/* Book/robot body */}
        <rect x="2.5" y="4" width="24" height="20" rx="3.4" fill="var(--primary-color, #C8623B)" />
        {/* Eyes */}
        <circle className={styles.eye} cx="10.2" cy="12" r="3" fill="#F5EDDD" />
        <circle className={`${styles.eye} ${styles.eyeRight}`} cx="19" cy="12" r="3" fill="#F5EDDD" />
        {/* Mouth */}
        <rect className={styles.mouth} x="8" y="18.4" width="13" height="2.4" rx="1.2" fill="#F5EDDD" />
        {/* Sound waves */}
        <path className={styles.wave} d="M30 10 A5.4 5.4 0 0 1 30 18" />
        <path className={`${styles.wave} ${styles.wave2}`} d="M32.8 8 A8.6 8.6 0 0 1 32.8 20" />
        <path className={`${styles.wave} ${styles.wave3}`} d="M35.6 6 A11.8 11.8 0 0 1 35.6 22" />
      </svg>
      {label && <span className={styles.label}>{label}</span>}
    </div>
  );
}

export default ByopdfLoader;
